module.exports = "<strong>Änderung vom {{$ctrl.change.date|date:\"dd.MM.yyyy\"}}</strong> <table class=\"table table-responsive\"> <thead> <tr> <th>Item</th> <th>alter Wert</th> <th>neuer Wert</th> </tr> </thead> <tbody> <tr ng-repeat=\"item in $ctrl.change.changes\"> <td>{{item.fieldName}}</td> <td>{{item.oldValue}}</td> <td>{{item.newValue}}</td> </tr> </tbody> </table> <button class=\"btn btn-discard\" ui-sref=^> Zurück </button> ";


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp-files/modules/patients/components/treatment-steps-changelog/formview-changes.html
// module id = 328
// module chunks = 0